import React, { useState, useEffect } from 'react';

import { ImportError, RowError } from 'interfaces/api_import.interfaces';
import { RowErrorComponent } from './error_row.component';


interface ImportErrorProps {
  error: ImportError | null;
}

export const ImportErrorComponent: React.FC<ImportErrorProps> = ( { error } ) => {

  const [ mappedInnerErrors, setMappedInnerErrors ] = useState( new Map<number, Omit<RowError, 'rowNumber'>[]>() );

  /*---------------------------- Hooks ------------------------------*/
  useEffect( () => {
    if ( error && error.innerErrors ) {
      const map = error.innerErrors.reduce( ( currentMap, item ) => {
        if ( !currentMap.has( item.rowNumber ) ) {
          currentMap.set( item.rowNumber, [] );
        }
        currentMap.get( item.rowNumber )?.push( { err: item.err, msg: item.msg, field: item.field } );

        return currentMap;
      }, new Map<number, Omit<RowError, 'rowNumber'>[]>() );
      setMappedInnerErrors( map );
    } else {
      setMappedInnerErrors( new Map() );
    }
  }, [ error ] );

  /*---------------------------- Front ------------------------------*/
  return (
    <>
      {
        error != null && (
          <div className='flex flex-col max-h-[300px] p-2 gap-2 bg-gray-50/50 shadow-inner rounded-md overflow-y-auto'>
            <span className='text-[16px] font-medium text-red-500'>
              { error.msg }
            </span>
            {
              mappedInnerErrors.size > 0 && (
                <div className='flex flex-col px-2 gap-2 text-gray-800 text-[14px] font-normal'>
                  {
                    [ ...mappedInnerErrors.keys() ]
                      .map( key => {
                        const innerErrors = mappedInnerErrors.get( key );
                        let row = null;
                        if ( innerErrors && innerErrors.length > 0 ) {
                          row = <RowErrorComponent key={ key } rowNumber={ key } errors={ innerErrors } />;
                        }
                        return row;
                      } )
                  }
                </div>
              )
            }
          </div>
        )
      }
    </>
  );

};